module.exports = __webpack_public_path__ + "static/media/weather.7df3a5ae.png";